import type { TranslationDict } from "@repo/core";

export const de: TranslationDict = {
  // —— uiKeys ——
  "type.income": "Einnahme",
  "type.expense": "Ausgabe",
  "type.transfer": "Überweisung",

  "person.household": "Haushalt",
  "person.personal": "Persönlich",
  "person.partner": "Partner",
  "person.sideHustle": "Nebeneinkommen",

  "method.snowball": "Schneeball",
  "method.avalanche": "Lawine",

  "tx.log": "Transaktionsprotokoll",
  "tx.search": "Suchen…",
  "tx.allTypes": "Alle Typen",
  "tx.allCategories": "Alle Kategorien",
  "tx.fromDate": "Von Datum",
  "tx.toDate": "Bis Datum",
  "tx.minAmount": "Min",
  "tx.maxAmount": "Max",
  "tx.clearFilters": "Zurücksetzen",
  "tx.entries": "{n} Einträge",
  "tx.noMatch": "Keine Transaktionen entsprechen Ihren Filtern.",
  "tx.loadMore": "Mehr laden ({n} übrig)",
  "tx.importCsv": "CSV importieren",
  "tx.csv": "CSV",
  "tx.add": "Hinzufügen",
  "tx.edit": "Bearbeiten",
  "tx.delete": "Löschen",
  "tx.editAria": "Transaktion bearbeiten",
  "tx.deleteAria": "Transaktion löschen",
  "tx.deleteConfirm": "Diese Transaktion löschen?",
  "tx.col.date": "Datum",
  "tx.col.type": "Typ",
  "tx.col.amount": "Betrag",
  "tx.col.category": "Kategorie",
  "tx.col.account": "Konto",
  "tx.col.person": "Person",
  "tx.col.notes": "Notizen",
  "tx.account": "Konto",
  "tx.category": "Kategorie",
  "tx.chooseAccount": "— Konto wählen —",

  "txModal.edit": "Transaktion bearbeiten",
  "txModal.new": "Neue Transaktion",
  "txModal.editSub": "Bestehenden Eintrag aktualisieren",
  "txModal.newSub": "Ausgabe oder Einnahme erfassen",
  "txModal.type": "Transaktionstyp",
  "txModal.amount": "Betrag",
  "txModal.date": "Datum",
  "txModal.person": "Person / Mitglied",
  "txModal.personPh": "Haushalt, Max, Anna…",
  "txModal.category": "Kategorie",
  "txModal.chooseCategory": "— Kategorie wählen —",
  "txModal.notes": "Notizen / Beschreibung",
  "txModal.notesPh": "Optionale Details…",
  "txModal.recurring": "Wiederkehrende Transaktion",
  "txModal.freq.weekly": "Wöchentlich",
  "txModal.freq.monthly": "Monatlich",
  "txModal.freq.custom": "Benutzerdefiniertes Intervall",
  "txModal.intervalDays": "Tage dazwischen",
  "txModal.recurringHelp":
    "Zukünftige Einträge werden automatisch erzeugt. Sie können später eine einzelne Vorkommnis überspringen.",
  "txModal.series": "Wiederkehrende Serie",
  "txModal.scopeOne": "Nur dieses Vorkommnis",
  "txModal.scopeSeries": "Gesamte Serie (dieses und zukünftige)",
  "txModal.skip": "Dieses Vorkommnis überspringen",
  "txModal.skipConfirm":
    "Nur dieses Vorkommnis überspringen? Der Rest der Serie bleibt.",
  "txModal.saving": "Speichern…",
  "txModal.update": "Transaktion aktualisieren",
  "txModal.save": "Transaktion speichern",

  "csv.title": "CSV importieren",
  "csv.intro":
    "Spalten aus Ihrem Bankexport zuordnen, Vorschau prüfen, dann importieren.",
  "csv.mapping": "Spaltenzuordnung",
  "csv.mappingHint":
    "Links: Spaltenname aus Ihrer CSV. Rechts: jeder Spalte ein BudgetOS-Feld zuweisen.",
  "csv.preview": "Vorschau ({ok}/{total} gültig)",
  "csv.ignore": "Ignorieren",
  "csv.ok": "OK",
  "csv.importing": "Importiere…",
  "csv.importN": "{n} Zeilen importieren",
  "csv.readError": "CSV-Kopfzeilen konnten nicht gelesen werden.",
  "csv.badDate": "Ungültiges Datum",
  "csv.badAmount": "Ungültiger Betrag",
  "csv.noCategory": "Keine Kategorie",
  "csv.needAccount":
    "Fügen Sie vor dem Import Ihr erstes Konto unter Einstellungen hinzu — CSV-Zeilen brauchen ein Konto.",

  "cal.subtitle": "Tägliche Ausgaben und Sparphasen ohne Ausgaben verfolgen",
  "cal.prev": "Vorheriger Monat",
  "cal.next": "Nächster Monat",
  "cal.streak": "Serie ohne Ausgaben",
  "cal.streakSub": "aufeinanderfolgende Tage",
  "cal.noSpendDays": "Tage ohne Ausgaben",
  "cal.thisMonth": "diesen Monat",
  "cal.spendDays": "Tage mit Ausgaben",
  "cal.active": "aktiv",
  "cal.totalSpent": "Gesamt ausgegeben",
  "cal.avgDay": "Ø {amount}/Tag",
  "cal.title": "Ausgabenkalender (Tag anklicken für Details)",
  "cal.legend.noSpend": "Keine Ausgabe",
  "cal.legend.spend": "Ausgabetag",
  "cal.legend.today": "Heute",
  "cal.badge.noSpend": "Tag ohne Ausgaben",
  "cal.badge.spent": "Ausgegeben:",
  "cal.badge.income": "Einnahme:",
  "cal.cleanTitle": "Saubere Finanzserie!",
  "cal.cleanBody": "An diesem Tag keine Ausgaben erfasst. Weiter so!",
  "cal.txOnDate": "Transaktionen an diesem Datum ({n})",
  "cal.addForDate": "Transaktion für dieses Datum hinzufügen",

  "debt.title": "Schulden-Tilgungsrechner",
  "debt.totalDebt": "Gesamtschulden",
  "debt.totalInterest": "Gesamtzinsen",
  "debt.debtFreeDate": "Schuldenfrei ab",
  "debt.apr": "{n} % p.a.",
  "debt.currentBalance": "aktueller Saldo",
  "debt.minPay": "Min.-Rate",
  "debt.extra": "Extra",
  "debt.interest": "Zinsen",
  "debt.months": "{n} Monate",
  "debt.viewSchedule": "Vollständigen Tilgungsplan anzeigen",
  "debt.hideSchedule": "Tilgungsplan ausblenden",
  "debt.col.month": "Monat",
  "debt.col.payment": "Zahlung",
  "debt.col.principal": "Tilgung",
  "debt.col.interest": "Zinsen",
  "debt.col.balance": "Saldo",
  "debt.balance": "Saldo ({symbol})",
  "debt.rate": "Zinssatz (%)",
  "debt.minPayment": "Mindestzahlung",
  "debt.extraPayment": "Sondertilgung",
  "debt.chartTitle": "Kombinierter Schuldenstand im Zeitverlauf",
  "debt.payoffOrderSnowball": "Tilgungsreihenfolge (kleinster Saldo zuerst)",
  "debt.payoffOrderAvalanche": "Tilgungsreihenfolge (höchster Zinssatz zuerst)",
  "debt.exportSchedule": "Plan exportieren",
  "debt.edit": "Bearbeiten",

  "mb.exportMonth": "Diesen Monat exportieren",
  "mb.income": "Einnahmen",
  "mb.expenses": "Ausgaben",
  "mb.target": "Ziel {amount}",
  "mb.budget": "Budget {amount}",
  "mb.allocation": "Monatliche Ausgabenverteilung",
  "mb.byGroup": "Nach Gruppe (Bedarf / Wünsche / Sparen)",
  "mb.topExpense": "Top-Ausgabenkategorien",
  "mb.incomeSources": "Einkommensquellen",

  "rule.netIncome": "Monatliches Nettoeinkommen",
  "rule.distribution": "50/30/20-Verteilung",
  "rule.breakdown": "Detaillierte Aufschlüsselung",
  "rule.visual": "Visueller Vergleich",
  "rule.targetPct": "Ziel: {n} % des Einkommens",
  "rule.actual": "Tatsächlich:",
  "rule.unclassified": "{n} % des Einkommens sind nicht klassifiziert oder unverbraucht",
  "rule.status.ahead": "Vor dem Ziel",
  "rule.status.onTrack": "Auf Kurs",
  "rule.status.below": "Unter dem Ziel",
  "rule.status.over": "Über dem Budget",
  "rule.status.under": "Unter dem Ziel",

  "sf.title": "Sparziele (Sinking Funds)",
  "sf.addFund": "Fonds hinzufügen",
  "sf.totalSaved": "Gesamt gespart",
  "sf.saved": "Gespart",
  "sf.target": "Ziel",
  "sf.remaining": "Verbleibend",
  "sf.monthsLeft": "Monate übrig",
  "sf.needMonth": "Bedarf/Monat",
  "sf.contribute": "+ Einzahlen",
  "sf.contributePrompt": "Zu „{name}“ hinzufügen\nAktuell: {current}\nBetrag:",
  "sf.deleteConfirm": "„{name}“ löschen?",
  "sf.due": "Fällig {date}",
  "sf.newTitle": "Neues Sparziel",
  "sf.name": "Name",
  "sf.icon": "Symbol",
  "sf.namePh": "z. B. Urlaub",
  "sf.fundIcon": "Fondssymbol",
  "sf.targetAmount": "Ziel",
  "sf.targetDate": "Zieldatum",
  "sf.alreadySaved": "Bereits gespart",
  "sf.color": "Farbe",
  "sf.empty": "Noch keine Sparziele. Fügen Sie eines hinzu, um zu sparen!",

  "cf.title": "Monatlicher Cashflow",
  "cf.titleYear": "Monatlicher Cashflow · {year}",
  "cf.netSurplus": "Nettoüberschuss",
  "cf.income": "Einnahmen",
  "cf.expenses": "Ausgaben",
  "cf.expense": "Ausgabe",
  "cf.netFlow": "Nettofluss",
  "cf.pctSaved": "{n} % gespart",
  "cf.mode.bars": "Gruppierte Balken",
  "cf.mode.flow": "Sanfter Verlauf",
  "cf.mode.net": "Nettoüberschuss",
  "cf.avgIncome": "Ø Einnahmen",
  "cf.avgExpenses": "Ø Ausgaben",
  "cf.avgNet": "Ø Nettoüberschuss",
  "cf.perMo": "/Mo.",
  "cf.peak": "Höchststand: {month} ({amount})",
  "cf.maxExp": "Max. Ausg.: {month} ({amount})",
  "cf.png": "PNG",

  "settings.dataMgmt": "Datenverwaltung & Prüfung",
  "settings.backupTitle": "Sichern & Wiederherstellen",
  "settings.backupDesc":
    "Laden Sie ein JSON-Backup aller lokalen Daten herunter oder stellen Sie aus einem früheren Export wieder her.",
  "settings.pdfTitle": "Jährlicher PDF-Bericht",
  "settings.pdfDesc":
    "Offline-PDF nach Maß: Cover, KPIs, Cashflow, Budget, 50/30/20, Schulden, Sparziele und Nettovermögen — mit eingebetteten Diagrammen.",
  "settings.currencyLocale": "Währung & Region",
  "settings.theme": "Design",
  "settings.helpSection": "Hilfe",
  "settings.openFaq": "FAQ öffnen",
  "settings.currency": "Währung",
  "settings.preview": "Vorschau",
  "settings.negative": "Negativ:",
  "settings.compact": "Kompakt:",
  "settings.footer": "BudgetOS · Alle Daten werden lokal auf diesem Gerät gespeichert.",
  "settings.deleteCategory":
    "Diese Kategorie löschen? Transaktionen behalten Beträge, verlieren aber die Verknüpfung.",
  "settings.deleteAccount": "Dieses Konto löschen?",
  "settings.noCategories": "Noch keine Kategorien — fügen Sie oben eine hinzu.",
  "settings.icon": "Symbol",
  "settings.name": "Name",
  "settings.monthlyTarget": "Monatsziel",
  "settings.group": "Gruppe",
  "settings.accountNameLabel": "Kontoname",
  "settings.openingBalance": "Anfangssaldo",
  "settings.type": "Typ",
  "settings.perMonth": "{amount}/Mo.",
  "settings.categoryIcon": "Kategoriesymbol",
  "settings.title": "Einstellungen",
  "settings.subtitle": "Erscheinungsbild, Sprache, Kategorien und Daten anpassen.",
  "settings.language": "Sprache",
  "settings.languageSection": "Sprache & Region",
  "settings.datePreview": "Datumsvorschau",
  "settings.timePreview": "Zeitvorschau",
  "settings.currencyPreview": "Währungsvorschau",
  "settings.relativePreview": "Relative Zeit",
  "settings.categories": "Kategorien",
  "settings.accounts": "Konten",
  "settings.restoreDefaults": "Standardkategorien wiederherstellen",
  "settings.restoreDefaultsConfirm":
    "Alle Kategorien durch den Standardsatz ersetzen (Lebensmittel, Miete usw.)? Benutzerdefinierte Kategorien werden entfernt.",
  "settings.addFirstAccount":
    "Fügen Sie Ihr erstes Konto hinzu, um Girokonto, Ersparnisse, Schulden und Vermögen zu verfolgen.",
  "settings.loadDemo": "Demo-Daten laden",
  "settings.loadDemoDesc":
    "Löscht alle Daten und füllt 12 Monate realistischer Einnahmen, Ausgaben, Schulden und Ersparnisse.",
  "settings.loadDemoBtn": "Demo-Daten laden",
  "settings.loadingDemo": "Laden…",
  "settings.clearAll": "Alle Daten löschen",
  "settings.clearAllDesc":
    "Löscht dauerhaft Transaktionen, Konten, Schulden und Sparziele. Standardkategorien werden wiederhergestellt. Nicht rückgängig zu machen.",
  "settings.clearConfirm": "Ja, alles löschen",
  "settings.clearing": "Löschen…",
  "settings.clearedDone":
    "Alle persönlichen Daten gelöscht. Standardkategorien sind bereit — fügen Sie bei Bedarf ein Konto hinzu und erfassen Sie Transaktionen.",
  "settings.demoLoaded": "Demo-Daten geladen! 12 Monate Transaktionen sind bereit.",
  "settings.calcCheck": "Berechnungsprüfung",
  "settings.runVerification": "Prüfskript ausführen",
  "settings.calcCheckDesc":
    "Bestätigt, dass Dashboard, Budget, Kalender und Faustregeln weiterhin stimmen.",
  "settings.emptyAccounts": "Erstes Konto hinzufügen",
  "settings.categoryName": "Kategoriename",
  "settings.accountName": "z. B. Girokonto",

  "theme.curated": "Ausgewählte Looks",
  "theme.fineTune": "Akzent feinjustieren",
  "theme.corners": "Ecken",
  "theme.accent.default": "Ozeanblau",
  "theme.accent.mint": "Pastellmint",
  "theme.accent.sand": "Warmer Sand",
  "theme.accent.midnight": "Mitternacht",
  "theme.accent.cyberpunk": "Cyberpunk",
  "theme.radius.none": "Eckig",
  "theme.radius.sm": "Dezent",
  "theme.radius.md": "Standard",
  "theme.radius.lg": "Abgerundet",
  "theme.radius.full": "Pille",
  "theme.clean": "Clean",
  "theme.cleanBlurb": "Weich & freundlich",
  "theme.fintech": "Fintech",
  "theme.fintechBlurb": "Dicht & präzise",
  "theme.minimal": "Minimal",
  "theme.minimalBlurb": "Editorial & ruhig",
  "theme.forest": "Forest",
  "theme.forestBlurb": "Petrol & warmes Creme",

  "layout.brand": "BudgetOS",
  "layout.tagline": "Jahresplaner",
  "layout.collapse": "Einklappen",
  "app.loading": "BudgetOS wird geladen…",
  "app.newTx": "Transaktion hinzufügen",
  "app.help": "Hilfe",

  "print.tagline": "Jahresbudget & Vermögensplaner · Erstellt {date}",
  "print.footer": "Offline-first · Daten bleiben auf diesem Gerät",

  "nw.month": "Monat",
  "nw.totalAssets": "Gesamtvermögen ({symbol})",
  "nw.totalDebts": "Gesamtschulden ({symbol})",
  "nw.title": "Nettovermögen-Tracker",
  "nw.logMonth": "Monat erfassen",
  "nw.current": "Aktuelles Nettovermögen",
  "nw.vsLastMonth": "vs. Vormonat",
  "nw.assets": "Vermögen",
  "nw.debts": "Schulden",
  "nw.debtRatio": "Schuldenquote",
  "nw.monthsTracked": "Erfasste Monate",
  "nw.logForm": "Nettovermögen erfassen",
  "nw.trend": "Nettovermögen-Trend",
  "nw.accounts": "Kontenaufschlüsselung",
  "nw.saveLog": "Eintrag speichern",
  "nw.netWorth": "Nettovermögen",

  "common.noData": "Keine Daten gefunden",
  "common.add": "Hinzufügen",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.close": "Schließen",
  "common.export": "Exportieren",
  "common.all": "Alle",
  "common.person": "Person",
  "common.year": "Jahr",
  "common.loading": "Laden…",
  "common.newTransaction": "Neue Transaktion",
  "common.uncategorized": "Ohne Kategorie",
  "common.mainAccount": "Hauptkonto",

  "currency.USD": "US-Dollar ($)",
  "currency.EUR": "Euro (€)",
  "currency.GBP": "Britisches Pfund (£)",
  "currency.CAD": "Kanadischer Dollar (CA$)",
  "currency.AUD": "Australischer Dollar (A$)",
  "currency.MXN": "Mexikanischer Peso (MX$)",
  "currency.JPY": "Japanischer Yen (¥)",
  "currency.CHF": "Schweizer Franken (CHF)",
  "currency.BRL": "Brasilianischer Real (R$)",
  "currency.INR": "Indische Rupie (₹)",

  "palette.mint": "Minze",
  "palette.sky": "Himmel",
  "palette.coral": "Koralle",
  "palette.lemon": "Zitrone",
  "palette.lavender": "Lavendel",

  // —— non-ui ——
  "nav.group.setup": "Einmal einrichten",
  "nav.group.daily": "Täglich nutzen",
  "nav.group.where": "Wo Sie stehen",
  "nav.group.wealth": "Vermögen aufbauen",
  "nav.dashboard": "Übersicht",
  "nav.monthly": "Monatsbudget",
  "nav.transactions": "Transaktionen",
  "nav.calendar": "Ausgabenkalender",
  "nav.rule503020": "50/30/20-Regel",
  "nav.networth": "Nettovermögen",
  "nav.debt": "Schulden tilgen",
  "nav.sinking": "Sparziele",
  "nav.settings": "Einstellungen",
  "nav.bottom.home": "Start",
  "nav.bottom.log": "Protokoll",
  "nav.bottom.budget": "Budget",
  "nav.bottom.debt": "Schulden",
  "nav.bottom.wealth": "Vermögen",

  "group.income": "Einnahmen",
  "group.needs": "Bedarf",
  "group.wants": "Wünsche",
  "group.savings": "Sparen",

  "accountType.checking": "Girokonto",
  "accountType.savings": "Sparkonto",
  "accountType.asset": "Vermögenswert",
  "accountType.debt": "Schuld",

  "cat.cat-sal": "Gehalt",
  "cat.cat-side": "Nebeneinkommen",
  "cat.cat-div": "Dividenden",
  "cat.cat-rent": "Miete / Hypothek",
  "cat.cat-util": "Nebenkosten",
  "cat.cat-groc": "Lebensmittel",
  "cat.cat-ins": "Versicherungen",
  "cat.cat-trans": "Transport",
  "cat.cat-health": "Gesundheit",
  "cat.cat-eat": "Essen gehen",
  "cat.cat-ent": "Unterhaltung",
  "cat.cat-shop": "Einkaufen",
  "cat.cat-sub": "Abonnements",
  "cat.cat-travel": "Reisen",
  "cat.cat-emerg": "Notfallfonds",
  "cat.cat-invest": "Investitionen",
  "cat.cat-ret": "Altersvorsorge (401k)",

  "demo.acc-check": "Chase Girokonto",
  "demo.acc-sav": "HYSA-Sparkonto",
  "demo.acc-cc1": "Visa-Kreditkarte",
  "demo.acc-car": "Autokredit",
  "demo.acc-inv": "Depot",
  "demo.acc-401k": "401(k)",
  "demo.dbt-cc": "Visa-Kreditkarte",
  "demo.dbt-car": "Autokredit",
  "demo.dbt-sl": "Studienkredit",
  "demo.sf-hol": "Urlaubsreise",
  "demo.sf-emg": "Notfallfonds",
  "demo.sf-car": "Anzahlung neues Auto",
  "demo.sf-home": "Hausreparaturen",
  "demo.sf-tech": "Neues Laptop",
  "demo.note.overDining": "Abendessen mit Freunden",
  "demo.note.workLunch": "Geschäftliches Mittagessen",
  "demo.note.weekendOut": "Wochenendausflug",

  "qs.unzip.title": "Bevor du startest: Ordner entpacken",
  "qs.unzip.windows":
    "Windows: Rechtsklick auf die .zip-Datei -> \"Alle extrahieren\" -> Speicherort waehlen.",
  "qs.unzip.mac":
    "Mac: Doppelklick auf die .zip-Datei - sie wird automatisch neben der Original-Zip entpackt.",
  "qs.unzip.open":
    "Oeffne den erstellten Ordner (gleicher Name wie die Zip-Datei). Darin findest du index.html, diese Anleitung und einen Ordner namens assets.",
  "qs.unzip.warn":
    "Verschiebe oder benenne index.html nicht einzeln um und nimm sie nicht aus diesem Ordner heraus - sie muss neben dem assets-Ordner bleiben, um zu funktionieren.",

  "demo.banner":
    "Das ist eine Live-Demo von BudgetOS — Beispieldaten, wird bei jedem Besuch zurückgesetzt.",
  "demo.readOnly":
    "Das ist eine Vorschau-Demo. Änderungen werden nicht gespeichert — holen Sie die Vollversion auf Etsy für Ihr eigenes Budget.",
  "demo.cta": "Vollversion holen",
  "demo.ctaHint": "Setzen Sie VITE_ETSY_URL, um diesen Button mit Ihrem Etsy-Listing zu verknüpfen.",

  "help.title": "Hilfe & FAQ",
  "help.close": "Hilfe schließen",
  "help.replayTour": "Schnellstart-Tour erneut abspielen",
  "help.quickStart": "Schnellstart-Leitfaden öffnen (PDF)",
  "help.quickStartHtml": "HTML-Version öffnen",
  "help.q0": "Wie funktionieren Sichern und Wiederherstellen?",
  "help.a0":
    "Einstellungen → Sichern & Wiederherstellen lädt eine JSON-Datei mit allen Kategorien, Transaktionen, Schulden und Fonds. Importieren Sie diese Datei im gleichen oder einem anderen Browser, um die Totals genau wiederherzustellen. Sichern Sie regelmäßig — diese Datei ist Ihre einzige portable Kopie.",
  "help.q1": "Wie übertrage ich Daten auf ein neues Gerät oder einen neuen Browser?",
  "help.a1":
    "Exportieren Sie ein Backup auf dem alten Gerät, öffnen Sie BudgetOS auf dem neuen und importieren Sie das Backup. Tun Sie das, bevor Sie Standortdaten löschen oder den Browser wechseln.",
  "help.q2": "Wie setze ich alle Daten zurück?",
  "help.a2":
    "Einstellungen → Alle Daten löschen entfernt dauerhaft Transaktionen, Konten, Schulden und Sparziele und stellt die Standardkategorien wieder her. Konten werden nicht neu angelegt. Ein Neuladen bringt die Demo nur zurück, wenn Sie Demo-Daten laden tippen. Nur Kategorien: Standardkategorien wiederherstellen.",
  "help.q3": "Wie ändere ich Währung oder Sprache?",
  "help.a3":
    "Einstellungen → Währung für die Geldformatierung. Einstellungen → Sprache & Region für die App-Sprache. Gespeicherte Beträge bleiben gleich.",
  "help.q4": "Funktioniert alles offline?",
  "help.a4":
    "Ja. Sobald die App geladen ist, braucht BudgetOS kein Internet. Diagramme, Schulden, Exporte und Backups laufen lokal.",
  "help.q5": "Welche Browser werden unterstützt?",
  "help.a5":
    "Aktuelle Chrome, Firefox, Edge und Safari. Nutzen Sie einen modernen Browser mit IndexedDB. Privates Surfen kann Daten beim Schließen löschen.",
  "help.q6": "Wichtig: HTML-Datei nach dem Speichern nicht verschieben",
  "help.a6":
    "Wenn Sie BudgetOS über file:// öffnen (typisch bei Etsy-Downloads), binden manche Browser — besonders Safari — den Speicher an diesen Pfad. Exportieren Sie ein Backup, bevor Sie die Datei umbenennen oder verschieben, und importieren Sie danach erneut.",
  "help.q7": "PDF zeigt URL oder Datum im Rand — ist das ein Fehler?",
  "help.a7":
    "Jahresbericht und Abschnitts-PDFs werden offline mit jsPDF erzeugt (nicht dem Browser-Druckdialog), mit BudgetOS-Kopfzeilen, Seitenzahlen und Diagrammen. Wenn Sie trotzdem den Browserdruck nutzen, können Sie Kopf-/Fußzeilen im Dialog abschalten.",

  "tour.skip": "Überspringen",
  "tour.back": "Zurück",
  "tour.next": "Weiter",
  "tour.done": "Loslegen",
  "tour.step": "Schritt {n} von {total}",
  "tour.choice.eyebrow": "Willkommen",
  "tour.choice.title": "Wie möchten Sie starten?",
  "tour.choice.body":
    "Einmal wählen. Demo-Daten können Sie später unter Einstellungen laden oder löschen.",
  "tour.choice.sample": "Mit Beispieldaten erkunden",
  "tour.choice.sampleDesc": "Lädt ein realistisches Demo-Jahr zum Ausprobieren.",
  "tour.choice.empty": "Mit meinen Daten starten",
  "tour.choice.emptyDesc": "Leere App — nur Standardkategorien. Fügen Sie Ihre erste Transaktion hinzu, wenn Sie bereit sind.",
  "tour.s0.title": "Ihre Daten bleiben auf diesem Gerät",
  "tour.s0.body":
    "BudgetOS ist offline-first. Alles liegt in diesem Browser — kein Konto, keine Cloud, kein Tracking.",
  "tour.s1.title": "Jederzeit eine Transaktion hinzufügen",
  "tour.s1.body":
    "Tippen Sie auf + (oder Transaktionen → Hinzufügen), um Einnahmen oder Ausgaben zu erfassen. Totals aktualisieren sich sofort.",
  "tour.s2.title": "Einstellungen & Backups",
  "tour.s2.body":
    "In den Einstellungen ändern Sie Währung, Design, Kategorien und laden ein JSON-Backup herunter. Exportieren Sie vor dem Browserwechsel.",
  "tour.s3.title": "Demo-Daten jederzeit laden",
  "tour.s3.body":
    "Einstellungen → Demo-Daten laden füllt ein realistisches Jahr. Alle Daten löschen entfernt sie, wenn Sie eigene Zahlen nutzen wollen.",
  "tour.s4.title": "Hilfe ist immer da",
  "tour.s4.body": "Öffnen Sie diese Tour oder die FAQ jederzeit über ?. Sie sind startklar.",

  "empty.accounts.networth":
    "Fügen Sie unter Einstellungen Ihr erstes Konto hinzu, um hier Salden zu sehen.",
  "empty.debts":
    "Noch keine Schulden. Laden Sie Demo-Daten oder fügen Sie Schulden bei der Konten-Einrichtung hinzu — dieser Bildschirm bleibt bereit.",
  "empty.tx.noAccount":
    "Noch keine Konten — Speichern ist trotzdem möglich. Fügen Sie bei Bedarf unter Einstellungen Ihr erstes Konto hinzu.",

  "dash.yearGlance": "Jahr auf einen Blick — {year}",
  "dash.downloadReport": "Jahresbericht herunterladen",
  "dash.buildingPdf": "PDF wird erstellt…",
  "dash.savingsGoal": "Fortschritt Sparziel",
  "dash.savingsRateTarget": "Sparquote · Ziel 20 %",
  "dash.rateVsTarget": "Quote vs. 20 %-Ziel",
  "dash.monthHighlights": "Monats-Highlights",
  "dash.kpi.moneyIn": "Geld rein",
  "dash.kpi.moneyOut": "Geld raus",
  "dash.kpi.leftover": "Übrig",
  "dash.kpi.savingsRate": "Sparquote",
  "dash.kpi.totalSaved": "Gesamt gespart",

  "pdf.tagline": "Offline-Jahresplaner",
  "pdf.cover.disclaimer":
    "Zahlen entsprechen den BudgetOS-Berechnungen auf dem Bildschirm. Vollständig offline erzeugt.",
  "pdf.generated": "Erstellt {date}",
  "pdf.page": "Seite {n} von {total}",
  "pdf.view": "Ansicht: {person}",
  "pdf.title.annual": "Jahresbericht {year}",
  "pdf.period.detail": "Jahresbericht {year} · Detail {month}",
  "pdf.section.yearGlance": "Jahr auf einen Blick",
  "pdf.section.cashFlow": "Monatlicher Cashflow",
  "pdf.section.budget": "Monatsbudget — {month} {year}",
  "pdf.section.rule": "50/30/20-Verteilung",
  "pdf.section.debts": "Schuldenübersicht",
  "pdf.section.funds": "Sparziele",
  "pdf.section.netWorth": "Nettovermögen",
  "pdf.col.kpi": "KPI",
  "pdf.col.value": "Wert",
  "pdf.col.month": "Monat",
  "pdf.col.in": "Rein",
  "pdf.col.out": "Raus",
  "pdf.col.leftover": "Übrig",
  "pdf.col.category": "Kategorie",
  "pdf.col.target": "Ziel",
  "pdf.col.actual": "Ist",
  "pdf.col.variance": "Abweichung",
  "pdf.col.group": "Gruppe",
  "pdf.col.bucket": "Topf",
  "pdf.col.amount": "Betrag",
  "pdf.col.pctIncome": "% vom Einkommen",
  "pdf.col.targetPct": "Ziel-%",
  "pdf.col.debt": "Schuld",
  "pdf.col.balance": "Saldo",
  "pdf.col.apr": "Zinssatz",
  "pdf.col.interest": "Zinsen",
  "pdf.col.months": "Monate",
  "pdf.col.payoff": "Tilgung",
  "pdf.col.fund": "Fonds",
  "pdf.col.saved": "Gespart",
  "pdf.col.progress": "Fortschritt",
  "pdf.col.moNeeded": "Bedarf/Mo.",
  "pdf.col.assets": "Vermögen",
  "pdf.col.debts": "Schulden",
  "pdf.col.net": "Netto",
  "pdf.col.account": "Konto",
  "pdf.col.type": "Typ",
  "pdf.col.payment": "Zahlung",
  "pdf.col.principal": "Tilgung",
  "pdf.sub.incomeSources": "Einkommensquellen",
  "pdf.sub.nws": "Bedarf / Wünsche / Sparen",
  "pdf.sub.expenseCats": "Ausgabenkategorien",
  "pdf.sub.accounts": "Kontenaufschlüsselung",
  "pdf.kpi.moneyIn": "Geld rein",
  "pdf.kpi.moneyOut": "Geld raus",
  "pdf.kpi.leftover": "Übrig",
  "pdf.kpi.savingsRate": "Sparquote",
  "pdf.kpi.totalSaved": "Gesamt gespart",
  "pdf.savingsGoal": "Sparziel: {actual} / {target}",
  "pdf.debtSummary":
    "Gesamtschulden {debt} · Gesamtzinsen {interest} · Schuldenfrei {date}",
  "pdf.nwSummary": "Netto {net} · Vermögen {assets} · Schulden {debts}",
  "pdf.empty.debts": "Keine Schulden erfasst.",
  "pdf.empty.funds": "Keine Sparziele erfasst.",
  "pdf.empty.chart": "Für diesen Zeitraum kein Diagramm verfügbar.",
  "pdf.empty.rule":
    "Keine Ausgabenverteilung in diesem Zeitraum — Ist-Werte sind 0.",
  "pdf.chart.cashFlow": "Monatlicher Cashflow",
  "pdf.chart.income": "Einnahmen",
  "pdf.chart.expense": "Ausgaben",
  "pdf.chart.rule": "50/30/20 · {month} {year}",
  "pdf.chart.netWorthTrend": "Nettovermögen-Trend",
  "pdf.chart.netWorth": "Nettovermögen",
  "pdf.chart.assets": "Vermögen",
  "pdf.chart.debts": "Schulden",
  "pdf.chart.emptySpend": "Keine Ausgaben in diesem Zeitraum",
  "pdf.chart.emptyHint":
    "Bedarf / Wünsche / Sparen erscheinen, sobald dieser Monat Ausgaben hat.",
  "pdf.amortization": "Tilgung — {name}",
  "pdf.payoffInterest": "Tilgung {date} · Zinsen {interest}",
};
